export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-5">
              关于我们
            </h2>
            <div className="text-sm text-foreground-600 leading-relaxed space-y-4">
              <p>
                <strong className="text-foreground-900">51黑料</strong>是国内领先的娱乐八卦视频聚合平台，致力于为广大吃瓜群众提供最新、最全、最热的黑料视频与吃瓜视频内容。我们整合全网优质的娱乐资讯资源，涵盖<strong className="text-foreground-900">51黑料在线观看</strong>、明星八卦、综艺揭秘、影视动态、网红翻车等多元内容分区。
              </p>
              <p>
                平台每日实时更新超过500条热门视频内容，覆盖全网热点事件。用户可以在51黑料网在线观看一区二区的完整资源，享受高清流畅的观看体验。无论是想看<strong className="text-foreground-900">51黑料视频</strong>还是追踪最新的<strong className="text-foreground-900">51黑料吃瓜视频</strong>，这里都是你的最佳选择。
              </p>
              <p>
                我们始终坚持内容为王、用户体验至上的原则，为每一位访问者提供安全、快速、无广告干扰的浏览环境。51黑料在线看，随时随地掌握娱乐八卦第一手资讯。
              </p>
            </div>
          </div>
          <div className="flex-1 w-full max-w-md">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20modern%20media%20platform%20concept%20visual%20with%20warm%20amber%20and%20dark%20aesthetic%2C%20digital%20content%20hub%2C%20cinematic%20composition%2C%20entertainment%20technology%2C%20clean%20futuristic%20look%2C%20no%20people%2C%20no%20text&width=800&height=600&seq=about-51hl&orientation=landscape"
                alt="51黑料平台介绍"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}